import { forwardRef } from 'react';

import { ValidableSection } from '@/policy/component/Validation/ValidableSection';
import { Car } from '@/policy/types/PolicyCoverage';
import { ValidationResult } from '@/policy/types/ValidationResult';

import { CarSectionsTable } from './CarSectionsTable';

interface CarSectionProps {
  car: Car;
  carIdentifier: string;
  validation: ValidationResult;
  onValidationChange: (validation: ValidationResult) => void;
  isSelected: boolean;
  onTableClick: (sectionUuid: string) => void;
}

export const CarSection = forwardRef<HTMLDivElement, CarSectionProps>(
  (
    {
      car,
      carIdentifier,
      validation,
      onValidationChange,
      isSelected,
      onTableClick,
    },
    ref,
  ) => {
    return (
      <ValidableSection
        ref={ref}
        className="my-4"
        sectionIdentifier={carIdentifier}
        validation={validation}
        onValidationChange={onValidationChange}
        isSelected={isSelected}
        onTableClick={onTableClick}
      >
        <CarSectionsTable car={car} />
      </ValidableSection>
    );
  },
);

CarSection.displayName = 'CarSection';
